import { render } from "./NewsShoutPanel.vue?vue&type=template&id=14f524fe&scoped=true"
import script from "./NewsShoutPanel.vue?vue&type=script&lang=js"
export * from "./NewsShoutPanel.vue?vue&type=script&lang=js"

import "./NewsShoutPanel.vue?vue&type=style&index=0&id=14f524fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f524fe"]])

export default __exports__